import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/index.css';
import * as serviceWorker from './serviceWorker';
import 'react-mdl/extra/material.css';
import 'react-mdl/extra/material.js';

ReactDOM.render(
      <App/>
  ,document.getElementById('root')
);

serviceWorker.unregister();
